<template>
  <div>
    <el-select
      :placeholder="$t('Seçin')"
      filterable
      v-model="selected" 
      @change="emitChange"
      style="width: 100%"
    >
      <el-option
        v-for="item in data"
        :key="item.centerId"
        :label="item.name"
        :value="item.centerId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { GetApiToken, GetContracts } from "../../services/carep";


export default {
  props: {
    value: [Number, String],
  },
  data() {
    return {
      data: [],
      selected: this.value,
    };
  },
  methods: {
    async fetchContracts() {
      try {
        const tokenResponse = await GetApiToken();
        const jwtToken = tokenResponse.result.jwt;

        const response = await GetContracts(jwtToken);

        this.data = response.result.map((item) => ({
          centerId: item.centerid,
          name: item.name,
        }));
      } catch (error) {
        console.error("Error fetching contracts:", error);
        this.$message.error("Contracts data could not be loaded.");
      }
    },
    emitChange() {
      const selectedOption = this.data.find(item => item.centerId === this.selected);
      this.$emit("input", this.selected);
      this.$emit("update:name", selectedOption ? selectedOption.name : '');
    },
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    },
  },
  mounted() {
    this.fetchContracts();
  },
};
</script>

<style lang="scss" scoped></style>
